import { ReactElement, useMemo } from 'react'
import Info from 'components/shared/Info'
import AccommodationAdditionalPromoInfo from 'components/shared/Promotions/components/AccommodationAdditionalPromoInfo'
import moment from 'moment'
import { IconVariant } from 'components/shared/Icon/types'
import { useApp } from 'store/steps'
import { FormattedMessage } from 'react-intl'
import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { usePromotions } from 'components/shared/Promotions/utils/usePromotions'

const AccommodationInfoContainer = () => {
    const {
        isBlackPromoForCreatorVisibleOutside,
        isBirthdayPromoForCreatorVisibleOutside,
        isCityBreakPromoActive,
        isSummerSaleForCreatorVisibleOutside,
    } = usePromotions()

    const { isCreatorAccommodation } = useApp()

    const visibleDescriptionInfo = useMemo((): {
        icon: IconVariant
        component: ReactElement
    } => {
        // <-- TODO: do zmiany na tegoroczny dropdown z opisem promocji
        if (isCityBreakPromoActive) {
            if (isCreatorAccommodation) {
                return {
                    icon: 'discount',
                    component: (
                        <FormattedMessage
                            id="promo.city_break.discount_info_accommodation"
                            defaultMessage="City break: zarezerwuj wizytę w parku na min. 2 dni z noclegiem dla co najmniej 2 gości i baw się przez 2 dni w cenie 1 biletu! Promocja trwa do 29 maja."
                        />
                    ),
                }
            }
            return {
                icon: 'discount',
                component: (
                    <FormattedMessage
                        id="promo.city_break.discount_info"
                        defaultMessage="Promocja dla gości Suntago Village naliczy się po dodaniu noclegu."
                    />
                ),
            }
        }
        // TODO -->

        return {
            icon: 'tooltip',
            component: (
                <FormattedMessage
                    id="accommodation.discount_info"
                    defaultMessage="Za pierwszą dobę noclegu otrzymasz 10% zniżki na pierwszy dzień wizyty w parku. Każda kolejna doba pobytu to aż 50% zniżki na kolejny dzień wodnych atrakcji!"
                />
            ),
        }
    }, [isCreatorAccommodation, isCityBreakPromoActive])

    return (
        <>
            {moment().isBefore('2023-05-01') ? (
                <AccommodationAdditionalPromoInfo />
            ) : (
                <Box mb={[24, 40]} isFullWidth>
                    <Info
                        color="success"
                        variantType={visibleDescriptionInfo.icon}
                    >
                        {visibleDescriptionInfo.component}

                        {isBlackPromoForCreatorVisibleOutside && (
                            <Text variant="bodySmall" color="grayscale_900">
                                <FormattedMessage
                                    id="promo.accommodation.discount_black_week_warning"
                                    defaultMessage="<span>Uwaga:</span> Promocja nie łączy się z promocją Black Weekend."
                                    values={{
                                        span: (chunks: string[]) => (
                                            <>
                                                <strong>{chunks}</strong>
                                            </>
                                        ),
                                    }}
                                />
                            </Text>
                        )}
                        {isBirthdayPromoForCreatorVisibleOutside && (
                            <Text variant="bodySmall" color="grayscale_900">
                                <FormattedMessage
                                    id="promo.accommodation.discount_birthday_promotion"
                                    defaultMessage="<span>Uwaga:</span> Promocja nie łączy się z promocją Piąte Urodziny Suntago."
                                    values={{
                                        span: (chunks: string[]) => (
                                            <>
                                                <strong>{chunks}</strong>
                                            </>
                                        ),
                                    }}
                                />
                            </Text>
                        )}
                        {isSummerSaleForCreatorVisibleOutside && (
                            <Text variant="bodySmall" color="grayscale_900">
                                <FormattedMessage
                                    id="promo.accommodation.discount_summer_sale_warning"
                                    defaultMessage="<span>Uwaga:</span> Promocja nie łączy się z Letnią Wyprzedażą."
                                    values={{
                                        span: (chunks: string[]) => (
                                            <>
                                                <strong>{chunks}</strong>
                                            </>
                                        ),
                                    }}
                                />
                            </Text>
                        )}
                    </Info>
                </Box>
            )}
        </>
    )
}

export default AccommodationInfoContainer
